import React, { useEffect, useState } from 'react'
import './BidListPage.css'
import { SlCalender } from "react-icons/sl";
import { HiOutlineClock } from "react-icons/hi";
import { FaChampagneGlasses } from "react-icons/fa6";
import { PiUsers } from 'react-icons/pi';

import FiltersSidebar from './FiltersSidebar';
import PartyPackageCard from './PartyPackageCard';
import searchIcon from './image/search-icon.svg'
import { IoSearchOutline } from "react-icons/io5";
import BitDetailedViewCard from './BitDetailedViewCard';
import PriceSummary from './OrderSummery';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Pagination } from 'antd';
import CustomPagination from './CustomPagination';
import PartyPackageCardSkeleton from './PartyPackageCardSkeleton';
import { API_BASE_URL } from '../utils';
import { IoLocationOutline } from "react-icons/io5";



export default function BidListPage() {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const sourcePage = searchParams.get("source");


    const userdata = JSON.parse(localStorage.getItem("userData"));

    const [isExpanded, setIsExpanded] = useState(false);
    const [data, setData] = useState([]);
    const [leads, setLeads] = useState([]);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [bids, setBids] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [selectedCard, setSelectedCard] = useState(null);
    const [loading, setLoading] = useState(true);

    const [gallery, setGallery] = useState([]);
    const [events, setEvents] = useState([]);


    const [packageDetails, setPackageDetails] = useState(null);


    const [city, setCity] = useState(null);
    const [area, setArea] = useState(null);
    const [club, setClub] = useState(null);
    const [packageName, setPackageName] = useState(null);

    const fetchUpcomingEvents = async (lat, lng, userId) => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('latitude', lat);
            formData.append('longitude', lng);
            formData.append('user_id', userId);

            const url = sourcePage === "table" ? `${API_BASE_URL}/master/APIs/ClubTable/getUserBids` : `${API_BASE_URL}/master/APIs/ClubPackage/getGroupBookingUserBids`;

            const response = await axios.post(url,
                formData
            );

            if (response.data.status === true) {
                setData(response.data.data);
            } else {
                console.warn('No events found:', response.data.msg);
                setData([]); // Clear if no events
            }
        } catch (error) {
            console.error('Error fetching upcoming events:', error);
            setData([]);
        }
        finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        if (data && id) {
            const matchedItem = Object.values(data).find((item) => item.id === id);

            if (matchedItem) {
                const { bids, ...rest } = matchedItem;

                setLeads([rest]);
                setBids(bids || []);
                setCity(rest.city);
                setArea(rest.area);

            } else {
                setLeads([]);
                setBids([]);
            }
        }
    }, [data, id]);


    const bidStats = [
        { label: 'My BIDs', count: bids.length },
        { label: 'View BIDs', count: 0 },
        { label: 'Active BIDs', count: bids.length },
    ];


    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const latStr = latitude.toString();
                    const lngStr = longitude.toString();

                    setLatitude(latStr);
                    setLongitude(lngStr);

                    fetchUpcomingEvents(latStr, lngStr, userdata.id);
                },
                (error) => {
                    alert('Please enable Geo Location Service to find events in your locality.');
                    console.error('Error in finding location:', error);
                }
            );
        } else {
            console.error('Geolocation is not available in this browser.');
        }
    }, []);

    const paginatedData = bids.slice((page - 1) * limit, page * limit);


    const handleFetchPackageDetails = async () => {
        try {
            const formdata = new FormData();
            formdata.append("city", city);
            formdata.append("area", area);
            formdata.append("club", club);
            formdata.append("title", packageName);

            const response = await axios.post(
                "https://partywitty.com/master/APIs/Web/packageDetails",
                formdata
            );

            if (response.data.status === "true") {
            } else if (response.data.data && response.data.data.length > 0) {
                setPackageDetails(response.data.data[0]);

            } else {
                console.error("No data found in response:", response.data);
            }
        } catch (error) {
            console.error("Error fetching package details:", error);
        }
    }

    const fetchClubDetails = async () => {
        try {
            const payloadData = new FormData();

            const clean = (str) => str?.toLowerCase().trim().replace(/\s+/g, ' ');
            payloadData.append("city", clean(city));
            payloadData.append("area", clean(area));
            payloadData.append("club", clean(selectedCard?.clubName));


            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/Web/getClubDetails`,
                payloadData
            );

            if (response.data?.data) {
                console.log("get API Response:", response.data);
                setGallery(response.data.data.gallery || []);
                setEvents(response.data.data.events || []);
            } else {
                console.warn("No data received from getClubDetails API.");
                return null;
            }
        } catch (error) {
            console.error("Error fetching club details:", error);
            return null;
        }
    };

    useEffect(() => {
        if (city && area && club && packageName) {
            handleFetchPackageDetails();
            fetchClubDetails();
        }
    }, [city, area, club, packageName]);

    useEffect(() => {
        if (selectedCard) {
            setPackageName(selectedCard.title);
            setClub(selectedCard.clubName);
        }
    }, [selectedCard]);


    useEffect(() => {
        if (paginatedData && paginatedData.length > 0 && !selectedCard) {
            setSelectedCard(paginatedData[0]);
        }
    }, [paginatedData]);


    useEffect(() => {
        if (page) {
            window.scrollTo(0, 0, { behavior: 'smooth' });
        }
    }, [page]);




    const formatPackageData = (data) => {
        if (!data) return null;

        const split = (str) => str?.split("###") || [];

        return {
            veg: {
                Soups: { items: split(data.soups), choice: data.soups_choice, image: "https://images.unsplash.com/photo-1611068120813-eca5a8cbf793?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                Starters: { items: split(data.starter), choice: data.starter_choice, image: "https://images.unsplash.com/photo-1632433796615-0ae72b6ab1b5?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fHN0YXRlciUyMGZvb2R8ZW58MHx8MHx8fDA%3D" },
                MainCourse: { items: split(data.maincourse), choice: data.maincourse_choice, image: "https://images.unsplash.com/photo-1599904191183-015402e01e82?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWFpbiUyMGNvdXJzZSUyMHZlZyUyMHBhbmVlciUyMGZvb2R8ZW58MHx8MHx8fDA%3D" },
                Rice: { items: split(data.rice), choice: data.rice_choice, image: "https://images.unsplash.com/photo-1596560548464-f010549b84d7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8cmljZSUyMGZvb2R8ZW58MHx8MHx8fDA%3D" },
                Breads: { items: split(data.breads), choice: data.breads_choice, image: "https://images.unsplash.com/photo-1586026779826-a5205f0ff4e0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fGJyZWFkJTIwZm9vZHxlbnwwfHwwfHx8MA%3D%3D" },
                Desserts: { items: split(data.desserts), choice: data.desserts_choice, image: "https://images.unsplash.com/photo-1661985887301-65bbb5a28b94?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8RGVzc2VydHMlMjBmb29kfGVufDB8fDB8fHww" },
            },
            nonVeg: {
                Soups: { items: split(data.nonveg_soups), choice: data.nonveg_soups_choice, image: "https://images.unsplash.com/photo-1627880872609-f7ddd76616c2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGNoaWNrZW4lMjBTb3VwcyUyMG5vbiUyMHZlZyUyMGZvb2R8ZW58MHx8MHx8fDA%3D" },
                Starters: { items: split(data.nonveg_starter), choice: data.nonveg_starter_choice, image: "https://images.unsplash.com/photo-1616811625651-07a1268d769f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGNoaWNrZW4lMjBTdGFydGVycyUyMG5vbnZlZyUyMGZvb2R8ZW58MHx8MHx8fDA%3D" },
                MainCourse: { items: split(data.nonveg_maincourse), choice: data.nonveg_maincourse_choice, image: "https://images.unsplash.com/photo-1597577652129-7ffad9d37ad4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzJ8fGNoaWNrZW4lMjBTdGFydGVycyUyMG5vbnZlZyUyMGZvb2R8ZW58MHx8MHx8fDA%3D" },
                Rice: { items: split(data.nonveg_rice), choice: data.nonveg_rice_choice, image: "https://images.unsplash.com/photo-1628606338096-686cf7dba76a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mzl8fGJpcnlhbmklMjBTdGFydGVycyUyMG5vbnZlZyUyMGZvb2R8ZW58MHx8MHx8fDA%3D" },
                Desserts: { items: split(data.nonveg_desserts), choice: data.nonveg_desserts_choice, image: "https://images.unsplash.com/photo-1661985887301-65bbb5a28b94?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8RGVzc2VydHMlMjBmb29kfGVufDB8fDB8fHww" },
            },
            drinks: {
                Whiskey: { items: split(data.whiskey), choice: data.whiskey_choice, image: "https://images.unsplash.com/photo-1603596311111-b43c809e02a1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFdoaXNrZXl8ZW58MHx8MHx8fDA%3D" },
                Vodka: { items: split(data.vodka), choice: data.vodka_choice, image: "https://images.unsplash.com/photo-1618412046321-f8127c4589ca?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Vm9ka2F8ZW58MHx8MHx8fDA%3D" },
                Rum: { items: split(data.rum), choice: data.rum_choice, image: "https://images.unsplash.com/photo-1523370885191-b4370ec51449?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8UnVtfGVufDB8fDB8fHww" },
                Gin: { items: split(data.gin), choice: data.gin_choice, image: "https://images.unsplash.com/photo-1551538827-9c037cb4f32a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Z2lufGVufDB8fDB8fHww" },
                Tequila: { items: split(data.tequila), choice: data.tequila_choice, image: "https://images.unsplash.com/photo-1516535794938-6063878f08cc?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8VGVxdWlsYXxlbnwwfHwwfHx8MA%3D%3D" },
                Beer: { items: split(data.beer), choice: data.beer_choice, image: "https://images.unsplash.com/photo-1567696911980-2eed69a46042?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8QmVlcnxlbnwwfHwwfHx8MA%3D%3D" },
                Cocktails: { items: split(data.cocktails), choice: data.cocktails_choice, image: "https://images.unsplash.com/photo-1509669803555-fd5edd8d5a41?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Q29ja3RhaWxzfGVufDB8fDB8fHww" },
                Mocktails: { items: split(data.mocktails), choice: data.mocktails_choice, image: "https://images.unsplash.com/photo-1527761939622-9119094630cf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8bW9ja3RhaWxzfGVufDB8fDB8fHww" },
                SoftDrinks: { items: split(data.soft_drinks), choice: data.soft_drinks_choice, image: "https://images.unsplash.com/photo-1629059042675-ce386c84cebf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fHNvZnQlMjBkcmlua3N8ZW58MHx8MHx8fDA%3D" },
                Juice: { items: split(data.juice), choice: data.juice_choice, image: "https://images.unsplash.com/photo-1603569283847-aa295f0d016a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8SnVpY2V8ZW58MHx8MHx8fDA%3D" },
            },
            // other: {
            //     GST: data.gst,
            //     CGST: data.cgst,
            //     SGST: data.sgst,
            //     Address: data.address?.replace(/\\r\\n/g, " "),
            //     Price: data.price,
            //     FoodServing: data.foodserving,
            //     AlcoholServing: data.alcoholserving,
            //     TermsAndConditions: data.tc,
            // }
        };
    };

    const formattedData = formatPackageData(packageDetails);


    const partydetails = () => {
        if (!formattedData) return {};

        return {
            MainCourse: formattedData.veg.MainCourse.choice === "All"
                ? formattedData.veg.MainCourse.items.length
                : parseInt(formattedData.veg.MainCourse.choice || 0),

            Starters: formattedData.veg.Starters.choice === "All"
                ? formattedData.veg.Starters.items.length
                : parseInt(formattedData.veg.Starters.choice || 0),

            drinks: formattedData.drinks.Cocktails.choice === "All"
                ? formattedData.drinks.Cocktails.items.length
                : parseInt(formattedData.drinks.Cocktails.choice || 0),

            SoftDrinks: formattedData.drinks.SoftDrinks.choice === "All"
                ? formattedData.drinks.SoftDrinks.items.length
                : parseInt(formattedData.drinks.SoftDrinks.choice || 0)
        };
    };

    // const details = partydetails();

    const getTotalGuests = (item) => {
        const male = parseInt(item?.male || 0, 10);
        const female = parseInt(item?.female || 0, 10);
        const kids = parseInt(item?.kids || 0, 10);
        return male + female + kids;
    };


    const handleBookNow = () => {
        if (sourcePage === "table") {
            navigate(`/table-booking/${selectedCard?.id}?sourcePage=${sourcePage}`);
        }
        else {
            navigate(`/packge-booking/${selectedCard?.id}?sourcePage=${sourcePage}`);
        }
    }

    return (
        <>
            <div className='bid-list'>
                <div className="container">

                    <div className="bid-list-header-design">
                        <div className='bit-list-details'>
                            <div className='bit-list-details-box'>
                                <SlCalender className='bit-list-d-icon' />
                                <span className='bit-list-d-title'>Date : </span>
                                <span className='bit-list-d-value'>{leads[0]?.party_date}</span>
                            </div>
                            <div className='bit-list-details-box'>
                                <HiOutlineClock className='bit-list-d-icon' />
                                <span className='bit-list-d-title'>Party Time slot : </span>
                                <span className='bit-list-d-value'>{leads[0]?.party_time}</span>
                            </div>
                            {sourcePage === "table" ? (
                                <div className='bit-list-details-box'>
                                    <IoLocationOutline />
                                    <span className='bit-list-d-title'>Location : </span>
                                    <span className='bit-list-d-value'>{leads[0]?.area}, {leads[0]?.city}</span>

                                </div>
                            ) : (
                                <div className='bit-list-details-box'>
                                    <FaChampagneGlasses className='bit-list-d-icon' />
                                    <span className='bit-list-d-title'>Package Type : </span>
                                    <span className='bit-list-d-value'>{leads[0]?.title}</span>
                                </div>
                            )}

                            <div className='bit-list-details-box'>
                                <PiUsers className='bit-list-d-icon' />
                                <span className='bit-list-d-title'>Pax : </span>
                                <span className='bit-list-d-value'>{getTotalGuests(leads[0])}</span>
                            </div>
                        </div>
                    </div>

                    <div className="bid-list-main-section">
                        <div className='bid-list-main-section-warper'>
                            <div className='bid-list-main-section-warper-sidebar'>
                                <FiltersSidebar />
                            </div>
                            <div className='bid-list-main-section-warper-card'>

                                <div className='bid-list-main-section-warper-card-header'>

                                    <div className='bid-list-main-section-warper-card-header-search'>
                                        <IoSearchOutline size={24} color="#7464E4" />
                                        <input type="search" placeholder="Search restaurant, package , etc" />
                                        <img src={searchIcon} alt="" />
                                    </div>

                                    <div className='bid-list-main-section-warper-card-header-filter'>
                                        {bidStats.map((item, index) => (
                                            <div
                                                className='bid-list-main-section-warper-card-header-filter-box'
                                                key={index}
                                            >
                                                <p className='bid-list-main-section-warper-card-header-filter-box-text'>
                                                    {item.label}
                                                    <span className='bid-list-main-section-warper-card-header-filter-box-text-span'>
                                                        {item.count}
                                                    </span>
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>


                                {bids.length === 0 ? (
                                    Array.from({ length: 4 }).map((_, index) => (
                                        <PartyPackageCardSkeleton />
                                    ))
                                ) : (
                                    paginatedData.map((item) => (
                                        <PartyPackageCard key={item.id} data={item}
                                            setSelectedCard={setSelectedCard}
                                            isSelected={selectedCard?.id === item.id}
                                            isListingPage={false}
                                            isVenueList={false}
                                            isTablebids={sourcePage === "table"}
                                            isbiding={true}
                                        />
                                    ))
                                )}
                                <CustomPagination
                                    currentPage={page}
                                    totalPages={Math.ceil(bids.length / limit)}
                                    onPageChange={(newPage) => setPage(newPage)}
                                />

                            </div>
                            <div className='bid-list-main-section-warper-card-details-price' style={{
                                position: !isExpanded ? 'sticky' : 'relative',
                                top: !isExpanded ? '90px' : '0px',
                            }}>

                                <BitDetailedViewCard
                                    formattedData={formattedData}
                                    selectedCard={selectedCard}
                                    gallery={gallery}
                                    events={events}
                                    packageDetails={packageDetails}
                                />

                                <div className='line-seperator'></div>
                                <div className='bid-list-main-section-warper-card-details-price-btn'>
                                    <button disabled={loading} onClick={handleBookNow}>
                                        {sourcePage !== "table" && `₹${selectedCard?.price} `}Book Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='bid-list-footer-section'>
                    <div className='bid-list-footer-section-warper'>
                        <div>
                            <h6>{selectedCard?.clubName}</h6>
                            {sourcePage === "table" ? <h4>{selectedCard?.extra} %</h4> : <h4>₹{selectedCard?.price || 0}</h4>}
                        </div>
                        <div className='bid-list-main-section-warper-card-details-price-btn-footer'>
                            <button onClick={handleBookNow}>
                                Book Now
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
